<template>
  <div class="popup-backdrop" v-if="open">
    <div class="popup-card error">
      <div class="error-content">
        <div class="error-title">{{ title ? title : 'Error' }}</div>
        <div class="error-message">{{ message }}</div>
        <button class="popup-btn" @click="handleDone">Done</button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  open: Boolean,
  message: String,
  title: String,
  onDone: Function,
})
function handleDone() {
  props.onDone()
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Archivo:wght@600&display=swap');
.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(30, 30, 40, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4000;
}

.popup-card.error {
  background: #fdeeed;
  border-radius: 11px;
  border: 1.5px solid #fac7c7;
  box-shadow: 0 2px 18px #e02d2d22;
  padding: 18px 28px 18px 18px;
  min-width: 320px;
  min-height: 52px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  font-family: 'Archivo', Arial, sans-serif;
  max-width: 50vw;
}

.error-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}

.error-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

.error-title {
  font-size: 1.11rem;
  color: #e02d2d;
  font-weight: 700;
  font-family: 'Archivo', Arial, sans-serif;
  margin-bottom: 1px;
}

.error-message {
  font-size: 1rem;
  color: #5f2323;
  font-weight: 500;
  font-family: 'Archivo', Arial, sans-serif;
  margin-bottom: 8px;
  word-break: break-word;
}

.popup-btn {
  align-self: flex-start;
  padding: 6px 22px;
  border: none;
  border-radius: 7px;
  font-size: 1.01rem;
  cursor: pointer;
  background: #e02d2d;
  color: #fff;
  transition: background 0.16s;
  font-weight: 600;
  font-family: 'Archivo', Arial, sans-serif;
  margin-top: 2px;
}
.popup-btn:hover {
  background: #b71c1c;
}
</style>
